var _require = require("./normalization"),
  deepNormalizeAttributes = _require.deepNormalizeAttributes,
  normalizeAttributeKey = _require.normalizeAttributeKey,
  normalizeAttributeValue = _require.normalizeAttributeValue;
var sendAnalyticsEvent = require("./sendAnalyticsEvent");
var sendPageViewEvent = require("./sendPageViewEvent");
var standardisedClickTracking = require("./standardisedClickTracking");
var extractLinkAttributes = require("./extractLinkAttributes");
module.exports = {
  deepNormalizeAttributes: deepNormalizeAttributes,
  normalizeAttributeKey: normalizeAttributeKey,
  normalizeAttributeValue: normalizeAttributeValue,
  sendAnalyticsEvent: sendAnalyticsEvent,
  sendPageViewEvent: sendPageViewEvent,
  standardisedClickTracking: standardisedClickTracking,
  extractLinkAttributes: extractLinkAttributes
};